import qs from 'qs'
import axios from '../../index'
/**
 * @description 获取采购商商品购物车商品
 * @author txw
 * @date 2019-03-13
 * @export
 */
export function loadCart (params) {
  return axios.post('/cart/loading', qs.stringify(params))
}
/**
 * @description 更新商品
 * @author txw
 * @date 2019-03-14
 * @export
 */
export function updateGoods (params) {
  return axios.post('/cart/updategoods', qs.stringify(params), {
    headers: {
      loading: true
    }
  })
}
/**
 * @description 处理商品库存不足或已下线登情况
 * @author txw
 * @date 2019-03-14
 * @export
 */
export function dealGoods (params) {
  return axios.post('/cart/deal', qs.stringify(params))
}
/**
 * @description 删除购物车商品
 * @author txw
 * @date 2019-03-18
 * @export
 */
export function delGoods (params) {
  return axios.post('/cart/delcart', qs.stringify(params))
}
/**
 * @description 判断能否改价
 * @author txw
 * @date 2019-04-01
 * @export
 */
export function isChangePrice (params) {
  return axios.post(`/cart/ischangeprice`, qs.stringify(params))
}
/**
 * @description 提交改价
 * @author txw
 * @date 2019-04-01
 * @export
 */
export function postChangePrice (params) {
  return axios.post(`/cart/changeprice`, qs.stringify(params))
}
/**
 * @description 加载购物车头部基础信息
 * @author txw
 * @date 2019-04-01
 * @export
 */
export function loadCartIndex (params) {
  return axios.post(`/cart/load-cart-index`, qs.stringify(params))
}
/**
 * @description 加载购物车头部基础信息
 * @author txw
 * @date 2019-04-01
 * @export
 */
export function postInvoice (params) {
  return axios.post(`/cart/invoicedo`, qs.stringify(params))
}
/**
 * @description 批量收藏
 * @author txw
 * @date 2019-04-09
 * @export
 */
export function addFavAll (params) {
  return axios.post(`/user/add-fav-all`, qs.stringify(params))
}
/**
 * @description 提交订单
 * @author txw
 * @date 2019-04-23
 * @export
 */
export function submitOrder (params) {
  return axios.post(`/order/submit`, qs.stringify(params))
}
